import React from 'react'

const Header = () => {
  return (
    <div>
        <h1 className='heading'>Notes</h1>
    </div>
  )
}

export default Header